import axios, { isAxiosError } from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

api.interceptors.response.use(
  response => response,
  error => {
    if (isAxiosError(error) && error.response) {
      if (error.status === 401 || error.response.status === 401) {
        localStorage.removeItem('@App:token');
        localStorage.removeItem('@App:partner');
        localStorage.removeItem('@App:user');
        localStorage.removeItem('@App:permissions');
        localStorage.removeItem('@App:workspaces');
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  },
);

export default api;
